/*
 * @description:
 * @Author: liwg
 * @Date: 2022-07-13 19:57:28
 * @LastEditors: zhaoyu zhaoy@normstar.com
 * @LastEditTime: 2024-08-07 10:43:08
 */
import { defineStore } from 'pinia'
import { omit } from 'lodash-es'
import { getEncryptedMessage } from '@/utils/ehome'
import { getUserInfo, logout as logoutApi } from '@/api/login'
import { getAppEnvConfig } from '@/utils/env'
import { setCookie } from '@/utils'
import { iamLogout } from '@/utils/nhIam'
import { router } from '../router'
import { useDeviceDebugStore } from './deviceDebug'
import { useEvaInfoStore } from './evaInfo'
import { useMonitorSessionStore } from './monitorSession'
import { useTabbarStore } from './tabbar'
import { store } from './index'
import type { RouteLocationNormalizedLoaded } from 'vue-router'
import type { LoginPageParams, LoginResult } from '@/api/login/type'
import type { UserInfo } from '@/api/evaInfo/type'
import type { Dayjs } from 'dayjs'
const { isEhome, isNhxm, oauthFlag } = getAppEnvConfig()
export const useUserStore = defineStore(
  'app-user',
  () => {
    const tabbar = useTabbarStore()
    const loginPageParams = ref<LoginPageParams>({})
    const evaInfoStore = useEvaInfoStore()
    const token = ref('')
    const deviceId = ref('')
    const loginType: any = ref('')
    const serverTime = ref<Dayjs>()
    const userInfo = ref<Partial<UserInfo>>({})
    const staffType = ref<'ids' | 'ext'>()
    const accountId = computed(() => unref(userInfo).id)
    const { portingConfig } = usePortingConfig()
    const isPureLoginPage = computed(() => {
      return unref(loginPageParams)?.name === 'nmLogin'
    })
    const resetMonitorContext = async () => {
      const monitorSessionStore = useMonitorSessionStore()
      const deviceDebugStore = useDeviceDebugStore()

      await Promise.allSettled([monitorSessionStore.resetSession(), deviceDebugStore.resetState()])
    }
    const loginSuccess = (
      {
        access_token,
        userInfo: userInfoRaw,
        user_id,
        username,
        login_type,
        staffType: staffTypeRaw
      }: LoginResult,
      route: RouteLocationNormalizedLoaded,
      isJump = true
    ) => {
      const previousAccountId = userInfo.value?.id
      const nextAccountId = userInfoRaw?.id || user_id

      if (previousAccountId && nextAccountId && previousAccountId !== nextAccountId) {
        resetMonitorContext()
      }

      const { params, query, name } = route || {}
      loginPageParams.value = {
        params,
        query,
        name: name!
      }
      token.value = access_token
      setCookie('token', access_token, { path: '/', httpOnly: false })
      setCookie('tester', 'eva', { path: '/', httpOnly: false })
      loginType.value = login_type
      userInfo.value = {
        ...userInfoRaw,
        user_id,
        username
      }
      staffType.value = staffTypeRaw
      //重置人脸识别记录
      evaInfoStore.resetComapareRecord()
      evaInfoStore.isCampare = false
      if (isJump) {
        if (!portingConfig.isOnlyEvalution) {
          tabbar.getLinkNum(userInfoRaw.validLinkNumMap)
        } else {
          router.push({ name: 'evaluation' })
        }
      }
    }

    const logout = async () => {
      const { query = {}, params = {}, name = '' } = unref(loginPageParams)
      if (isEhome) {
        const { objRes } = await getEncryptedMessage()
        const data: any = await getUserInfo(objRes)
        loginSuccess(
          {
            access_token: data.access_token,
            userInfo: {
              name: data.username,
              staffCode: data.staffCode,
              id: data.user_id
            },
            username: data.username,
            user_id: data.user_id,
            staffType: data.staffType,
            login_type: 'ehome'
          },
          {},
          false
        )
        router.go(0)
      } else if (!query.key) {
        await logoutApi()
        await resetMonitorContext()
        token.value = ''
        loginType.value = ''
        userInfo.value = {}
        if (isNhxm && oauthFlag) {
          // 南航项目点击退出登录接口
          iamLogout()
        } else {
          router.replace({ name, query, params })
        }
      } else {
        await resetMonitorContext()
        token.value = ''
        loginType.value = ''
        userInfo.value = {}
        router.replace({ name, query: omit(query, 'key'), params })
      }
    }

    return {
      token,
      loginType,
      serverTime,
      userInfo,
      staffType,
      loginPageParams,
      loginSuccess,
      isPureLoginPage,
      deviceId,
      logout,
      accountId
    }
  },
  {
    persist: {
      paths: [
        'token',
        'loginType',
        'userInfo',
        'serverTime',
        'staffType',
        'loginPageParams',
        'deviceId'
      ]
    }
  }
)

export function useUserStoreWithOut() {
  return useUserStore(store)
}
